import React from "react";
import Saurabh from "../../../images/SaurabhVedwal.jpg";
import FadeIn from "../../ui/FadeIn";

const Partnership = () => (
  <section className="ku-section bg-ku-gradient-soft">
    <div className="ku-container max-w-4xl">
      <FadeIn>
        <h2 className="ku-heading-lg text-center mb-4">Partnership & Collaboration Opportunities</h2>
        <p className="text-center text-gray-600 font-body text-lg mb-12">
          To discuss possible opportunities, kindly reach out to us at{" "}
          <a href="mailto:contactus@kindnessunlimited.in" className="text-ku-violet font-semibold">
            contactus@kindnessunlimited.in
          </a>
        </p>
        <h3 className="font-display text-2xl font-bold text-ku-royal text-center mb-8">Testimonals</h3>
      </FadeIn>
      <div className="max-w-2xl mx-auto">
        {[
          {
            quote: "Connecting with people and collecting their stories. I enjoyed listening their stories and sharing my own observations.",
            name: "Saurabh Kumar",
            role: "Volunteer, 1MillionStory Campaign",
            image: Saurabh,
          },
        ].map((t, i) => (
          <FadeIn key={t.name} delay={i * 0.08}>
            <div className="ku-glass rounded-ku-lg p-6 h-full">
              <p className="font-body text-gray-700 italic mb-6">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-4">
                <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-ku-soft" />
                <div>
                  <p className="font-display font-semibold text-ku-royal">{t.name}</p>
                  <p className="text-sm text-gray-500">{t.role}</p>
                </div>
              </div>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default Partnership;
